{
    "Adults": "Odrasli",
    "Children": "Otroci",
    "Childrens age": "Starost otrok",
    "Enter the age of each child": "Vnesite starost vsakega otroka",
    "Child": "Otrok",
    "age": "starost",
    "Age": "Starost",
    "Teens": "Najstniki",
    "adult": "{count} odrasel | {count} odrasla | {count} odrasla | {count} odrasli | {count} odrasli | {count} odraslih",
    "child": "{count} otrok | {count} otrok | {count} otroka | {count} otroci | {count} otroci | {count} otrok",
    "teen": "{count} najstnik | {count} najstnik | {count} najstnika | {count} najstniki | {count} najstniki | {count} najstnikov",
    "nights": "{count} noči | {count} noč | {count} noči | {count} noči | {count} noči | {count} noči",
    "rooms": "{count} sob | {count} soba | {count} sobi | {count} sobe | {count} sobe | {count} sob",
    "guests": "{count} gostov | {count} gost | {count} gosta | {count} gostje | {count} gostje | {count} gostov",
    "Count reviews :count": "{count} ocen | {count} ocena | {count} oceni | {count} ocene | {count} ocene | {count} ocen",
    "Were": "Kje",
    "Who": "Kdo",
    "When": "Kdaj",
    "Start typing to search...": "Vpišite kamp, državo ali destinacijo",
    "Type to search": "Vnesite za iskanje",
    "No options found": "Ni najdenih možnosti",
    "No results found": "Ni rezultatov",
    "Select guests": "Izberite goste",
    "Select arrival date": "Izberite datum prihoda",
    "Select date": "Za prikaz cene izberite datum v iskalniku",
    "Rooms": "Sobe",
    "Your order number is :order_number": "Številka vašega naročila: <b>{number}</b>",
    "Yout inquiry number is :order_number": "Številka vašega povpraševanje: <b>{number}</b>",
    "max_occupancy": "Max. {count} oseb | Max. {count} oseba | Max. {count} osebi | Max. {count} osebe | Max. {count} osebe | Max. {count} oseb",
    "No Pets": "Brez hišnih ljubljenčkov",
    "Pets Allowed": "Hišni ljubljenčki dovoljeni",
    "View Offer": "Poglej ponudbo",
    "bunk_beds": "Nadstropna postelja",
    "one_persons_bed": "Enojna postelja",
    "baby_bed": "Otroška posteljica",
    "double_bed": "Zakonska postelja",
    "child_bed": "Otroška postelja",
    "lying_beds": "Ležišča",
    "shower": "Tuš",
    "hair_dryer": "Sušilnik za lase",
    "toilet": "Stranišče",
    "espresso_machine": "Espresso aparat",
    "cook_place": "Kuhalna površina",
    "tea_coffee_making": "Čaj/kava",
    "dishwasher": "Pomivalni stroj",
    "cutlery": "Pribor",
    "plates": "Krožniki",
    "water_cooker": "Kuhalo za vodo",
    "kitchen": "Kuhinja",
    "microwave": "Mikrovalovna pečica",
    "refrigerator_with_freezer": "Hladilnik z zamrzovalnikom",
    "refrigerator": "Hladilnik",
    "freezer": "Zamrzovalnik",
    "dinner_table": "Jedilna miza",
    "dining_area": "Jedilni prostor",
    "sitting_area": "Sedežna garnitura",
    "loungeset": "Lounge garnitura",
    "garden_furniture": "Vrtno pohištvo",
    "garden": "Vrt",
    "terrace": "Terasa",
    "terrace_partly_roof": "Terasa delno pokrita",
    "veranda": "Veranda",
    "flat_screen_tv": "TV z ravnim zaslonom",
    "dvd_player": "DVD predvajalnik",
    "free_wifi": "Brezplačen WiFi",
    "wifi": "WiFi",
    "airco": "Klimatska naprava",
    "smoking_is_not_allowed": "Kajenje ni dovoljeno",
    "parking_included": "Parkirišče vključeno",
    "pets_allowed": "Hišni ljubljenčki dovoljeni",
    "pets_not_allowed": "Hišni ljubljenčki niso dovoljeni",
    "hangers": "Obešalniki",
    "wardrobe": "Garderobna omara",
    "coffee_apparatus": "Kavni aparat",
    "living_rooms": "Dnevni prostori",
    "beds": "Postelje",
    "count_child_chairs": "Otroški stoli",
    "count_bedrooms": "Spalnice",
    "count_bathrooms": "Kopalnice",
    "count_of_toilets": "Stranišča",
    "square_meter": "Velikost (m2)",
    "Description": "Opis",
    "Availability": "Razpoložljivost",
    "Available": "Možni datumi prihoda in odhoda",
    "Selected": "Izbrani termin",
    "Unavailable": "Prosto (samo bivanje)",
    "Arrival on this date is not possible. Nearest possible arrival: :nearest_date": "Prihod na ta datum ni mogoč. Najbližji možen prihod: {date}.",
    "Reviews": "Ocene in komentarji",
    "Service": "Storitve in dodatni stroški",
    "Location": "Lokacija",
    "Properties": "Objekti",
    "Book": "Rezerviraj",
    "Your reservation has been placed.": "Vaša rezervacija je bila uspešno oddana.",
    "We need to check the availability of the appointment. You can expect an offer within 48 hours.": "Razpoložljivost termina moramo preveriti. Ponudbo lahko pričakujete v roku 48 ur.",
    "Your inquiry has been sent.": "Vaše povpraševanje je bilo uspesno oddano.",
    "Related products": "Vas mogoče zanima tudi",
    "Facility offer": "Ponudba objekta",
    "How long": "Trajanje",
    "Search": "Iskanje",
    "Additional costs": "Dodatni stroški",
    "Please select availability dates to see the price and book.": "<strong>Za prikaz cene in možnost rezervacije:</strong> izberite datum prihoda (zeleno označeni datumi so na voljo), nato v polju »Trajanje« izberite dolžino bivanja.",
    "We must check the availability of accommodation in the selected period.": "Razpoložljivost nastanitve v izbranem terminu moramo preveriti.",
    "Product details": "Podrobnosti",
    "Related Products": "Podobne ponudbe",
    "Where?": "Kam?",
    "Select nights": "Izberite št. nočitev",
    "Filter": "Filtriraj",
    "Load More": "Naloži več",
    "Sort by": "Razvrsti po",
    "Name asc": "Ime (A - Z)",
    "Name desc": "Ime (Z - A)",
    "View Product": "Poglej ponudbo",
    "Total": "Skupaj",
    "Total for payment": "Skupaj za plačilo",
    "Additional options": "Dodatne možnosti",
    "There are no additional options available for your cart items.": "Ni na voljo dodatnih možnosti za izbran produkt.",
    "Items marked with * are paid at the property.": "* Postavke označene z * se plačajo v nastanitvi.",
    "Order details": "Povzetek naročila",
    "List of offers for": "Seznam ponudb za",
    "Max. number of people": "Najv. št. oseb",
    "Bedrooms": "Št. spalnic",
    "Pets allowed": "Hišni ljubljenčki",
    "Yes": "Da",
    "No": "Ne",
    "Your booking details": "Podrobnosti vaše rezervacije",
    "Check in": "Prijava",
    "Check out": "Odjava",
    "Number of nights and guests": "Št. nočitev in gostov",
    "Total results: :total": "Zadetkov: {total}",
    "Reset filters": "Ponastavi",
    "Accommodation": "Nastanitev",
    "Terms agreement": "Strinjam se in sem seznanjen s <a class='text-pink-600 underline' href='/pogoji-poslovanja'>pogoji poslovanja</a>.",
    "Continue to customer information": "Nadaljuj na vnos podatkov",
    "No products found.": "Ni najdenih produktov.",
    "Included in price": "Vključeno v ceno",
    "Mandatory surcharge": "Obvezno doplačilo",
    "At reception": "Na recepciji",
    "At reservation": "Ob rezervaciji",
    "First name": "Ime",
    "Last name": "Priimek",
    "Address": "Naslov",
    "Zip code": "Poštna številka",
    "City": "Mesto",
    "Country": "Država",
    "E-mail": "E-pošta",
    "Phone": "Telefon",
    "Submit": "Pošlji",
    "Order Summary": "Povzetek naročila",
    "Number of bedrooms": "Število spalnic",
    "Pets": "Hišni ljubljenčki",
    "Subscribe to our newsletter": "Naročite se na naše novice",
    "Subscribe to newsletter": "Naročite se na e-novice",
    "Newsletter promotion text": "Prejemajte posebne ponudbe in obvestila.",
    "Enter your email address": "Vnesite svoj e-poštni naslov",
    "Subscribe": "Naroči se",
    "Thank you for subscribing.": "Hvala za prijavo.",
    "Subscription failed. Please try again.": "Prijava ni uspela. Poskusite znova.",
    "By clicking the button you agree that Počitnice.si d.o.o. process and store your email address for the purpose of sending email newsletters in accordance with the <a href='/privacy-policy'>privacy policy</a>.": "S klikom na gumb se strinjate, da Počitnice.si d.o.o. obdela in shranjuje vaš e-poštni naslov za namen pošiljanja e-novic v skladu s <a href='/privacy-policy'>politiko zasebnosti</a>.",
    "We are redirecting you to the payment.": "Preusmerjamo vas na plačilo.",
    "Payment failed.": "Plačilo ni uspelo.",
    "An error occurred while processing your payment. Please try again later.": "Pri obdelavi plačila je prišlo do napake. Poskusite znova kasneje.",
    "Back to payment": "Nazaj na plačilo",
    "Price asc": "Cena (naraščajoče)",
    "Price desc": "Cena (padajoče)",
    "Our top picks": "Naši izbrani",
    "Booking holder": "Nosilec rezervacije",
    "Payment method": "Način plačila",
    "Notes": "Opombe",
    "Form validation error": "Nekateri podatki niso pravilni. Prosimo, popravite označene napake in poskusite znova.",
    "Loading": "Nalagam...",
    "I agree and am familiar with the <a href='{link}'>terms of business</a>.": "Strinjam se in sem seznanjen s <a class='text-pink-500 font-bold' href='/{link}'>pogoji poslovanja</a>.",
    "All stated wishes represent guest preferences only and are not subject to a confirmed reservation.": "Vse navedene želje predstavljajo zgolj preference gostov in niso predmet potrjene rezervacije.",
    "Send inquiry": "Pošlji povpraševanje",
    "Add": "Dodaj",
    "Remove": "Odstrani",
    "Loading your order ...": "Nalaganje vašega naročila ...",
    "Your reservation could not be completed.": "Vaše rezervacije ni bilo mogoče dokončati.",
    "The payment failed or was cancelled.": "Plačilo ni uspelo ali je bilo preklicano.",
    "Try again": "Poskusi znova",
    "Back to home": "Nazaj na začetek",
    "We will send you a message with the details of your order to your email address.": "Na vaš elektronski naslov vam bomo poslali sporočilo s podrobnostmi naročila.",
    "Customer reviews": "Mnenja strank",
    "Show more": "Prikaži več",
    "Show less": "Prikaži manj",
    "Locations": "Lokacije",
    "Regions": "Regije",
    "Countries": "Države",
    "Select an option": "Izberite možnost",
    "We were unable to redirect you to the payment provider. Please try again.": "Preusmeritev na ponudnika plačil ni uspela. Poskusite znova.",
    "Start your search": "Začnite z iskanjem",
    "Apply filters": "Uporabi filtre",
    "Back": "Nazaj",
    "Open gallery": "Odpri galerijo",
    "Not available for there dates. Select different dates.": "Ni na voljo za izbran termin.",
    "per night": "na noč",
    "from": "od",
    "Risk insurance": "Zavarovanje rizika odpovedi",
    "Insurance amount": "Zavarovalna vsota",
    "Risk insurance description": "Priporočamo vam sklenitev zavarovanja za primer odpovedi potovanja zaradi bolezni. Zavarovanje velja v primeru nepričakovanega poslabšanja zdravstvenega stanja enega od potnikov ali smrti v ožji družini in se lahko uveljavlja le ob predložitvi ustreznega potrdila. Povrne se celoten znesek vplačila, zmanjšan za znesek zavarovalnine in administrativnih stroškov. Odpoveste lahko do dneva odhoda. Zavarovanje ne velja za primer nosečnosti.",
    "I want to add risk cancellation insurance in the amount of": "Želim dodati zavarovanje rizika odpovedi v višini",
    "Newsletter": "E-novice",
    "The map shows the approximate location of the accommodation.": "Zemljevid prikazuje okvirno lokacijo nastanitve. Dejanska lokacija nastanitvene enote se lahko razlikuje.",
    "The photos are illustrative and not binding. Dimensions, room layout and equipment may differ from those shown. Please refer to the accommodation description.": "Fotografije so ilustrativne in niso zavezujoče. Mere, razpored prostorov in oprema se lahko razlikujejo od prikazanih. Prosimo, upoštevajte opis nastanitve.",
    "Product description": "Opis namestitve",
    "Property description": "Opis objekta",
    "Stay:": "Bivanje:",
    "Cancel": "Prekliči",
    "Add-on details": "Podrobnosti doplačila",
    "Add another": "Dodaj še enega",
    "Edit details": "Uredi podrobnosti",
    "Add to cart": "Dodaj v košarico",
    "Page is not available.": "Stran ni na voljo.",
    "Cart and checkout are available only with an active product in cart.": "Košarica in checkout sta na voljo samo, če je v košarici aktivna nastanitev.",
    "Your cart is empty.": "Vaša košarica je prazna.",
    "Add a product to your cart to continue to checkout.": "Za nadaljevanje na blagajno dodajte izdelek v košarico.",
    "Browse offers": "Prebrskaj ponudbe",
    "Read more": "Preberi več",
    "Quantity": "Količina",
    "Increase quantity": "Povečaj količino",
    "Decrease quantity": "Zmanjšaj količino",
    "Select your arrival date — available days are colored green.": "Izberite datum prihoda — razpoložljivi dnevi so obarvani zeleno.",
    "Select the length of stay. Only options available for the selected arrival date are displayed.": "Izberite dolžino bivanja. Prikazane so samo možnosti, ki so na voljo za izbrani datum prihoda.",
    "Select the number of people and enter the ages of the children.": "Izberite število oseb in vnesite starost otrok.",
    "Arrival and departure are only possible on the days marked in green. Your stay may also include the days marked in white.": "Prihod in odhod sta možna samo na zeleno označene dneve. Vaše bivanje pa lahko vključuje tudi belo označene dneve."
}
